document.addEventListener("product:variant-change", function (evt) {
  if (!evt.detail || !evt.detail.variant) {
    return;
  }

  var matchingOption = $(".custom-select-design option").filter(function() {
    return $(this).text().trim() === evt.detail.variant.title;
  });
  if (matchingOption.length) {
    $(".custom-select-design").val(matchingOption.val()).trigger('change');
  }
  $(".select2.select2-container").click();
});


const viewMore = document.getElementById("viewMore");
if (viewMore) {
  viewMore.addEventListener("click", () => {
    viewMore.classList.toggle("expanded");
  });
}
